import React from "react";
import { Card, Select, Spin } from "antd";
import {
  ComposedChart,
  Line,
  Bar,
  XAxis,
  YAxis,
  Tooltip as RechartsTooltip,
  CartesianGrid,
  ResponsiveContainer,
  Legend,
} from "recharts";

const { Option } = Select;

const AttritionGraph = ({
  attritionRate,
  timePeriod,
  setTimePeriod,
  loading,
}) => {
  const monthNames = {
    "01": "Jan",
    "02": "Feb",
    "03": "Mar",
    "04": "Apr",
    "05": "May",
    "06": "Jun",
    "07": "Jul",
    "08": "Aug",
    "09": "Sep",
    10: "Oct",
    11: "Nov",
    12: "Dec",
  };

  const data = (attritionRate || []).map((item) => ({
    timePeriod: monthNames[item.timePeriod] || item.timePeriod,
    attritionRate: parseFloat(item.attritionRate) || 0,
    headCount: parseFloat(item.headCount) || 0,
  }));

  const renderChart = () => {
    if (!data || data.length === 0) {
      return (
        <div
          style={{
            textAlign: "center",
            color: "#999",
            height: "320px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          No Data Available
        </div>
      );
    }

    return (
      <ResponsiveContainer width="100%" height={320}>
        <ComposedChart
          data={data}
          margin={{ top: 0, right: 0, bottom: 5, left: 0 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="timePeriod"
            tick={{ angle: -45, textAnchor: "end", fontSize: 12 }}
            label={{
              value:
                timePeriod === "M"
                  ? "Months"
                  : timePeriod === "Q"
                  ? "Quarters"
                  : "Years",
              position: "insideBottom",
              offset: -30,
              style: { fontSize: 14, fontWeight: 600 },
            }}
          />
          <YAxis
            yAxisId="left"
            orientation="left"
            label={{
              value: "Headcount",
              angle: -90,
              position: "insideLeft",
              style: { fill: "#666666", fontSize: 14, fontWeight: 600 },
            }}
            stroke="#666666"
          />
          <YAxis
            yAxisId="right"
            orientation="right"
            label={{
              value: "Attrition Rate (%)",
              angle: -90,
              position: "insideRight",
              style: { fill: "#666666", fontSize: 14, fontWeight: 600 },
            }}
            stroke="#666666"
            tickFormatter={(value) => `${value}%`}
          />
          <RechartsTooltip
            formatter={(value, name) => {
              if (name === "headCount") {
                return Math.abs(value);
              }
              return value;
            }}
          />
          <Legend
            wrapperStyle={{
              fontSize: "11px",
              fontWeight: "normal",
              paddingTop: "25px",
              display: "flex",
              justifyContent: "left",
              marginLeft: "10px",
              width: "fit-content",
            }}
          />
          <Bar
            yAxisId="left"
            dataKey="headCount"
            barSize={20}
            fill="rgba(13, 204, 204, 0.8)"
            name="Headcount"
          />
          <Line
            yAxisId="right"
            type="monotone"
            dataKey="attritionRate"
            stroke="rgba(22, 121, 255, 1)"
            strokeWidth={2}
            dot={{ r: 2 }}
            name="Attrition Rate (%)"
          />
        </ComposedChart>
      </ResponsiveContainer>
    );
  };

  return (
    <Card style={{ borderRadius: "16px" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 10,
          position: "relative",
        }}
      >
        <div
          style={{
            fontWeight: 700,
            fontSize: "16px",
            padding: "0px 8px 4px 8px",
          }}
        >
          Attrition Rate vs Headcount
        </div>
        <Select
          value={timePeriod}
          onChange={(val) => setTimePeriod(val)}
          style={{ width: 100 }}
        >
          <Option value="M">Monthly</Option>
          <Option value="Q">Quarterly</Option>
          <Option value="Y">Yearly</Option>
        </Select>
      </div>

      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            height: "320px",
            alignItems: "center",
          }}
        >
          <Spin />
        </div>
      ) : (
        renderChart()
      )}
    </Card>
  );
};

export default AttritionGraph;
